import React, { useState } from 'react';
import ServiceCard from './ServiceCard';
import { Link } from 'react-router-dom';
import { 
  DocumentTextIcon, QrCodeIcon, 
  ArrowsRightLeftIcon, CalendarIcon,
} from '@heroicons/react/24/outline';
import utilityServices from '../../../config/utilityServices';

const iconMap = {
  DocumentTextIcon: DocumentTextIcon,
  QrCodeIcon: QrCodeIcon,
  ArrowsRightLeftIcon: ArrowsRightLeftIcon,
  CalendarIcon: CalendarIcon,
};

const ServiceDashboard = () => {
  const [activeTab, setActiveTab] = useState('전체');

  const tabs = ['전체', '재무/회계', '생산성', '사주/운세'];

  const services = [
    {
      id: 'asset',
      icon: '💼',
      title: '자산/비품 구매',
      description: '설비, 비품, 차량 등 자산 구매 관련 분개를 추천합니다.',
      path: '/services/asset-purchase',
      serviceType: '재무/회계',
      available: true
    },
    {
      id: 'expense',
      icon: '💰',
      title: '비용 관리',
      description: '소모품비, 복리후생 등 비용 관련 분개를 추천합니다.',
      path: '/services/expense-management',
      serviceType: '재무/회계',
      available: true
    },
    {
      id: 'finance',
      icon: '🏦',
      title: '재무 활동',
      description: '차입금, 대여금, 예금 등 재무 관련 분개를 추천합니다.',
      path: '/services/financial-activities',
      serviceType: '재무/회계',
      available: true
    },
    {
      id: 'sales',
      icon: '🛍️',
      title: '매출/매입',
      description: '매출, 매입, 외상 관리에 필요한 분개를 추천합니다.',
      path: '/services/sales-purchase',
      serviceType: '재무/회계',
      available: true
    },
    {
      id: 'pdf',
      icon: '📄',
      title: 'PDF 분석 서비스',
      description: 'PDF 문서를 읽고 AI가 핵심 내용을 요약해드립니다.',
      path: '/tools/pdf-reader',
      serviceType: '생산성',
      available: true
    },
    {
      id: 'email-writer',
      icon: '✉️',
      title: '이메일 작성',
      description: 'AI가 상황에 맞는 적절한 이메일을 작성해드립니다.',
      path: '/tools/email-writer',
      serviceType: '생산성',
      available: true
    },
    {
      id: 'saju',
      icon: '🔮',
      title: 'AI 사주풀이',
      description: '생년월일과 태어난 시간을 바탕으로 사주팔자를 분석해드립니다.',
      path: '/services/fortune/saju',
      serviceType: '사주/운세',
      available: true
    },
    {
      id: 'report',
      icon: '📝',
      title: '개조식 보고서 작성',
      description: 'AI가 도와주는 전문적인 개조식 보고서 작성 서비스',
      path: '/services/report',
      serviceType: '생산성',
      available: true
    }
  ];

  const filteredServices = activeTab === '전체'
    ? services
    : services.filter(service => service.serviceType === activeTab);

  const allServices = [...services, ...utilityServices];

  return (
    <div className="bg-gray-50 min-h-screen py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">서비스 목록</h1>
        
        {/* 탭 메뉴 */}
        <div className="mb-8 flex overflow-x-auto">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 mr-2 rounded-full whitespace-nowrap transition-colors
                ${activeTab === tab 
                  ? 'bg-blue-600 text-white' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* 서비스 그리드 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredServices.map(service => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>

        {/* 유틸리티 서비스 섹션 추가 */}
        <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-6">유틸리티 도구</h2>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {utilityServices.map((service) => {
            const Icon = iconMap[service.icon] || DocumentTextIcon;
            
            return (
              <Link
                key={service.id}
                to={service.path}
                className="block bg-white rounded-lg shadow-md transition transform hover:scale-105 hover:shadow-lg"
              >
                <div className="p-6">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <Icon className="h-8 w-8 text-indigo-600" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">{service.title}</h3>
                      <p className="mt-1 text-sm text-gray-500">{service.description}</p>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServiceDashboard;
